<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-danger shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-200">
                <div class="row text-center justify-content-center">
                    <div class="col-12">
                        <h2 class="display-3 text-white">Erro 404 <span>Página não Encontrada!</span></h2>
                        <base-button type="secondary" @click="$router.go(-1)">Voltar</base-button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: 'error-404',
};
</script>
